export default __webpack_public_path__ + "static/media/Group 25.f7c63116.png";